import { registerCondition } from 'core/forms';

const isStatusInProgress = ({ model: { status } }) => ({
  condition: null,
  hasCondition: !status || status === 'in-progress',
});

registerCondition('isStatusInProgress', isStatusInProgress);

export default isStatusInProgress;
